import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppAddIcon } from "../../Icon/AppAddIcon";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";
import { IconButtonProps } from "@mui/material";

interface IAddToolButtonProps extends IconButtonProps {
    tooltip?: string
    onFileClick?: (file: File) => void;
}

export const AddToolButton = (props: IAddToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.Add}
        icon={<AppAddIcon />}
    />
);
